import {
  FACEBOOK_ADSET_FORM_DETAILS,
  FACEBOOK_ADSET_FORM_ERROR,
  FACEBOOK_ADSET_ID,
  FACEBOOK_ADSET_ERROR,
} from "../../types";

const AdSetReducer = (state, action) => {
  switch (action.type) {
    case FACEBOOK_ADSET_FORM_DETAILS:
      return { ...state, form_details: action.payload };

    case FACEBOOK_ADSET_FORM_ERROR:
      return { ...state, form_errors: action.payload };

    case FACEBOOK_ADSET_ID:
      return { ...state, adset_id: action.payload };

    case FACEBOOK_ADSET_ERROR:
      return { ...state, adset_error: action.payload };

    default:
      return state;
  }
};

export default AdSetReducer;